import * as func from './func';

// グローバル変数　設定
//window.progressTemp = 0;
//window.errorCount = 0;

$(function () {

    // ダウンロードボタン
    $('#downloadButton').on("click", function () {

        // オリジナルデータが存在する写真のUUIDを取得
        let uuid_list = [];
        $('.image_container').each(function () {
            if ($(this).find('.download_data').length !== 0) {
                uuid_list.push($(this).attr('id'));
            }
        });

        Swal.fire({
            title: uuid_list.length + '枚の写真をzip形式にまとめてダウンロードします',
            text: "ダウンロードが開始されるまで時間がかかる場合があります",
            showCancelButton: true,
            confirmButtonText: '続行する',
            cancelButtonText: 'キャンセル',
        }).then((result) => {
            if (result.isConfirmed) {
                // zipファイル作成へ
                zipArchives(uuid_list);
            }
        });
    });

    // オリジナルデータボタン
    $('#originalButton_one').on("click", function () {
        // 画像のuuidを取得
        // let uuid = $('.image_container').eq(swiper.realIndex).attr('id');
        let original_url = $('.image_box img').eq(swiper.realIndex).attr('data-src').replace('/thum/', '/original/');

        // 端末分岐
        if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/i)) {
            // スマホ・タブレットの場合　モーダルで表示

            $('.original_modal').find('.original_image_space').attr('src', `${mypath}images/loading.gif`);
            $('.original_modal').addClass('original_modal_active');
            $('.original_modal').find('.original_image_space').attr('src', `${original_url}`);

            $('.original_tip').text('元データを表示しています');
        } else {
            // PCの場合　別ウィンドウで表示
            window.open(original_url);
        }
    });

    // ダウンロードボタン（one）
    $('#downloadButton_one').on("click", function () {
        // 画像のuuidを取得
        let uuid = $('.image_container').eq(swiper.realIndex).attr('id');

        // 端末分岐
        if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/i)) {
            // スマホ・タブレットの場合　表示
            $('.download_modal').find('.download_image_space').attr('src', `${mypath}images/loading.gif`);
            $('.download_modal').addClass('download_modal_active');
            $('.download_modal').find('.download_image_space').attr('src', `${mypath}getimage/${uuid}`);

            $('.download_tip').text('▼ このサムネを長押しで保存できます');
        } else {
            // PCの場合　ダウンロード
            location.href = `${mypath}download/${uuid}`;
        }
    });

    // オリジナル imageModal 閉じるボタン
    $('.return_btn').on("click", function () {
        $('.original_modal').removeClass('original_modal_active');
    });

    // オリジナル imageModal 閉じるボタン
    document.addEventListener('click', (e) => {
        
        if (!e.target.closest('.download_tip') &&
            !e.target.closest('.download_modal') &&
            !e.target.closest('#downloadButton_one')
        ) {
            $('.download_modal').removeClass('download_modal_active');
        }
    });

});

// zipファイル作成
function zipArchives(uuid_list) {

    // form を動的に生成
    var form = document.createElement('form');
    form.action = mypath + 'zipdownload';
    form.method = 'POST';

    // body に追加
    document.body.append(form);

    // formdta イベントに関数を登録(submit する直前に発火)
    form.addEventListener('formdata', (e) => {
        var fd = e.formData;

        // データをセット
        fd.set('album_uuid', album_uuid);
        fd.set('uuid_list', JSON.stringify(uuid_list));
        fd.set('_token', $('meta[name="csrf-token"]').attr('content'))
    });

    // submit
    form.submit();
}
